import { render, staticRenderFns } from "./PeopleFilters.vue?vue&type=template&id=6d9edb80&"
import script from "./PeopleFilters.vue?vue&type=script&lang=js&"
export * from "./PeopleFilters.vue?vue&type=script&lang=js&"
import style0 from "./PeopleFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports